import React from "react";
import classNames from "classnames";
import { ResourceAvatar } from "@common/resourceAvatar";
import { Props } from "./types";
import { AddAllocationIcon } from "@common/assets/addAllocationIcon";
import styles from "./styles.scss";

function AllocationsList({ allocations, task, displayAllocationMenu }: Props) {
  return (
    <ul
      className={styles.allocationsList}
      onClick={(e) => {
        e.stopPropagation();
        displayAllocationMenu(task, e.clientX, e.clientY);
      }}
    >
      {allocations.slice(0, 2).map(({ resource }) => (
        <li key={resource.uuid} className={styles.allocation}>
          <ResourceAvatar resource={resource} />
        </li>
      ))}
      {allocations.slice(2).length > 0 && (
        <li className={classNames(styles.allocation, styles.summary)}>
          <p>+{allocations.slice(2).length}</p>
        </li>
      )}
      {allocations.length === 0 && (
        <li className={styles.allocation}>
          <div>
            <AddAllocationIcon className={styles.addAllocationIcon} />
          </div>
        </li>
      )}
    </ul>
  );
}

export { AllocationsList };
